import { CommonModule } from '@angular/common';
import { Component, OnInit, NgZone, ViewChild, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ModalController, NavParams, IonContent, IonicModule, Platform } from '@ionic/angular';
import { DeviceInputComponent } from 'src/app/components/device-input/device-input.component';
import { Position, Group, Zone, EditAdditionalFields, PositionUpdateFields, Level, PositionCardModalResult } from 'src/app/model';
import { ApiService, HelperProvider } from 'src/app/providers';
import { MapsService } from 'src/app/providers/maps/maps.service';
import { DmStoreService } from 'src/app/store/dm-store.service';

@Component({
  selector: 'app-device-bind-modal',
  templateUrl: './device-bind.modal.html',
  styleUrls: ['./device-bind.modal.scss'],
  standalone: true,
  imports: [IonicModule, FormsModule, CommonModule, DeviceInputComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class DeviceBindModalComponent implements OnInit {
  private native: boolean;

  public error: string;
  public position?: Position;
  public group?: Group;
  public zone?: Zone;
  public level?: Level;
  public customId: string | undefined;
  public networkId: string | undefined;
  public deviceForBind: string | undefined;
  private calibrated: boolean;

  @ViewChild(IonContent, { static: false }) content: IonContent;

  constructor(
    private modalController: ModalController,
    private navParams: NavParams,
    private api: ApiService,
    private helper: HelperProvider,
    private dmStoreStervice: DmStoreService,
    private ngZone: NgZone,
    private dmStoreService: DmStoreService,
    private platform: Platform,
    private maps: MapsService,
  ) { }

  async ngOnInit() {
    this.native = this.platform.is('capacitor') && this.platform.is('android');

    this.position = await this.navParams.get(EditAdditionalFields.Position);
    this.zone = await this.navParams.get(EditAdditionalFields.Zone);
    this.group = await this.navParams.get(EditAdditionalFields.Group);
    this.level = await this.navParams.get(EditAdditionalFields.Level);
    this.group = await this.navParams.get(EditAdditionalFields.Group);
    this.customId = this.position?.custom_id || '';
    this.networkId = this.position?.network_id || '';
  }

  public newDevice = (id?: string) => this.deviceForBind = id || undefined;
  public calibrationStatus = (status: boolean) => this.calibrated = status;

  public back() {
    this.modalController.dismiss();
  }

  public updatedCustomId = (customId: string) => this.customId = customId;
  public updatedNetworkId = (networkId: string) => this.networkId = networkId;

  public async save() {
    if (this.deviceForBind) {
      this.bindConfirm();
    }

    if (!this.position || this.customId === this.position?.custom_id) {
      return;
    }

    this.helper.showLoading();
    const updated: PositionUpdateFields = {
      lat: this.position.lat,
      lon: this.position.lon,
      custom_id: this.customId || null,
      group_id: this.position.group_id,
      group_inner_id: this.position.group_inner_id,
    };
    const save = await this.api.positions.update(updated, this.position.id, this.helper);

    if (save) {
      this.dmStoreStervice.updatePosition(this.position.id);
      this.helper.showToast('Position has been updated');
      this.modalController.dismiss();
    } else {
      this.helper.alert('Can\'t update position');
    }

    this.helper.hideLoading();
  }

  public async bindConfirm() {
    if (!this.calibrated && this.native) {
      this.helper.confirm(this.bindAction.bind(this), 'Are you sure you want to bind uncalibrated device?');
    } else {
      this.bindAction();
    }
  }

  public async bindAction() {
    if (!this.deviceForBind || !this.position) {
      return;
    }

    this.helper.showLoading();
    this.error = '';
    const result = await this.api.devices.bindDeviceToPosition(this.deviceForBind, { position_id: this.position.id });

    if (result.error) {
      this.ngZone.run(() => this.error = result.error || '');
    } else {
      this.maps.bound([{ lat: this.position.lat, lon: this.position.lon }]);
      this.dmStoreService.bindDevice(this.deviceForBind, this.position.id);
      const modalRes: PositionCardModalResult = {
        binded: this.deviceForBind,
      };
      this.modalController.dismiss(modalRes);
    }

    this.helper.hideLoading();
  }

  public blurInput() {
    this.content.scrollToBottom(500);
  }
}

